import React, { useState } from 'react'
import "./NavBar.css"
import { Link } from "react-scroll"

export default function NavBar() {

    const [showMediaBar, setShowMediaBar] = useState(false)

    function toggleMediaBar() {
        setShowMediaBar(!showMediaBar);
    }

    return (

        <div>
            <nav className='navBar'>
                <ul className='navParts'>
                    <ul className='nav-left'>
                        <a href="/"> <img src={require("./../../static/A-logo.png")} alt="Logo"/></a>
                    </ul>
                    <ul className='nav-right'>
                        <li> <Link to="Home" smooth={true} duration={1000}> Home </Link> </li>
                        <li> <Link to="About" smooth={true} duration={1000} > About </Link> </li>
                        <li> <Link to="Resume" smooth={true} duration={1000}> Resume </Link> </li>
                        <li> <Link to="Projects" smooth={true} duration={1000}> Projects </Link> </li>
                        <li> <Link to="Contact" smooth={true} duration={1000}> Contact </Link> </li>

                        <div className={showMediaBar ? "vanish" : "hamburger-icon"}>
                            <i className='fa fa-bars' onClick={toggleMediaBar}></i>
                        </div>
                        <div className={showMediaBar ? "close-icon" : "vanish"}>
                            <i className="fa fa-window-close" onClick={toggleMediaBar}></i>
                        </div>
                    </ul>
                </ul>
            </nav>

            <div className={showMediaBar ? "mobile-media-bar" : "vanish"}>
                <ul className='mobile-nav-right'>
                    <li> <Link to="Home" smooth={true} duration={1000} onClick={() => { setShowMediaBar(false) }}> Home </Link> </li>
                    <li> <Link to="About" smooth={true} duration={1000} onClick={() => { setShowMediaBar(false) }}> About </Link> </li>
                    <li> <Link to="Resume" smooth={true} duration={1000} onClick={() => { setShowMediaBar(false) }}> Resume </Link> </li>
                    <li> <Link to="Projects" smooth={true} duration={1000} onClick={() => { setShowMediaBar(false) }}> Projects </Link> </li>
                    <li> <Link to="Contact" smooth={true} duration={1000} onClick={() => { setShowMediaBar(false) }}> Contact </Link> </li>
                </ul>
            </div>

        </div>
    )
}
